import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CheckIcon = ({ ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M13.3346 4L6.0013 11.3333L2.66797 8'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='#1ead62'
      />
    </SvgIcon>
  );
};

export default CheckIcon;
